import Promise from 'bluebird';
import _ from 'lodash';
import PouchDB from 'pouchdb';

const cache = (() => {
    let db;

    const init = () => {
        db = new PouchDB('neogig');
    };

    const check = (values, response) => {
        if (values.length < response.length) {
            return false;
        }

        const t = values.filter(v => response.filter(r => r.id === v)).length;
        return t >= values.length;
    };

    const add = values => {
        if (!_.isArray(values)) {
            values = [values];
        }

        values = values.map(value =>
            Object.keys(value).reduce((pre, cur) => {
                pre[_.snakeCase(cur)] = values[cur];
            }, {})
        );

        return db.put(values);
    };

    const get = (values, options) =>
        new Promise((resolve, reject) => {
            const _success = response => resolve(response.docs);

            const _error = function (error) {
                console.error(error);
                return reject(error);
            };

            if (!values) {
                _error(new Error('Values are required'));
            }

            if (!_.isArray(values)) {
                values = [values];
            }

            const params = {
                selector: options.selector || {},
                fields: options.fields || null,
                sort: options.sort || null,
                limit: options.limit || null,
                skip: options.skip || null
            };

            params.selector['$or'] = values.map(v => ({ id: v }));

            return db.find(params)
                .then(_success)
                .catch(_error);
        });

    // API
    return {
        init,
        get,
        add,
        check
    };
})();

export default cache;



// WEBPACK FOOTER //
// ./src/scripts/api/cache.js